import { PlatformTrends } from "./types";

/** Prazni trendovi, prije nego stignu s backenda. */
export const initialPlatformTrends: PlatformTrends = {
  newTenants: [],
  mrr: [],
  combinations: [],
};
